import http from './http';

// Helper to extract a clean error message and throw
function handleError(error) {
  const msg = error?.response?.data?.message || error?.message || 'Request failed';
  throw new Error(msg);
}

// POST /api/v1/iam/groups
export async function createGroup(groupData) {
  try {
    const res = await http.post('/api/v1/iam/groups', groupData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/iam/groups
export async function listGroups(params = {}) {
  try {
    const res = await http.get('/api/v1/iam/groups', { params });
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/iam/groups/:id
export async function getGroupById(id) {
  try {
    const res = await http.get(`/api/v1/iam/groups/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// PATCH /api/v1/iam/groups/:id
export async function updateGroup(id, updateData) {
  try {
    const res = await http.patch(`/api/v1/iam/groups/${id}`, updateData);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// DELETE /api/v1/iam/groups/:id
export async function deleteGroup(id) {
  try {
    const res = await http.delete(`/api/v1/iam/groups/${id}`);
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// GET /api/v1/iam/test - Test IAM routes
export async function testIAM() {
  try {
    const res = await http.get('/api/v1/iam/test');
    return { data: res.data };
  } catch (e) { handleError(e); }
}

// Default export object with all group API functions
const groupAPI = {
  createGroup,
  listGroups,
  getGroupById,
  updateGroup,
  deleteGroup,
  testIAM
};

export default groupAPI;
